module.exports = __webpack_public_path__ + "media/images/noimage-285e2c46e2076833db09d5436a062c01.png";